import { useClassNames } from '@magnetic/hooks';
import { Plus } from '@magnetic/icons';
import React, { forwardRef } from 'react';
import './styles.css.js';
import { useAddableTag } from './use-addable-tag.js';

const iconSizes = {
  sm: 10,
  md: 12,
  lg: 16
};
const AddableTag = forwardRef(
  ({ className, onAdd, size = "md" }, ref) => {
    const { handleChange, handleOnAdd, value } = useAddableTag(onAdd);
    const classNames = useClassNames({
      "mds-rebuild-tag": true,
      "mds-tag-addable": true,
      [`mds-rebuild-tag-size-${size}`]: true,
      className
    });
    const hiddenSpanClassNames = useClassNames(
      classNames,
      "mds-tag-addable-hidden-text"
    );
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
      className: "mds-tag-addable-frame"
    }, /* @__PURE__ */ React.createElement(Plus, {
      className: "mds-tag-addable-icon",
      size: iconSizes[size],
      weight: "bold"
    }), /* @__PURE__ */ React.createElement("input", {
      className: classNames,
      onChange: handleChange,
      onKeyUp: handleOnAdd,
      placeholder: "Add",
      ref,
      type: "text",
      value: value || ""
    })), /* @__PURE__ */ React.createElement("span", {
      className: hiddenSpanClassNames
    }, (value == null ? void 0 : value.replace(" ", "-")) || "Add"));
  }
);

export { AddableTag };
//# sourceMappingURL=index.js.map
